import React from 'react';
import { Box, Container, Divider, Grid, Paper, Typography } from '@material-ui/core';

const PageWrapper = ({ title, children, actionButton, isPlain, maxWidth }) => {
  return (
    <Container maxWidth={maxWidth}>
      <Grid component={Paper} square={!isPlain} elevation={isPlain ? 0 : 1} container>
        <Grid item xs={12} component={Box} p={4} container>
          <Grid item xs={7} component={Box} py={2}>
            <Typography color="secondary" variant="subtitle2">
              {title}
            </Typography>
          </Grid>
          <Grid item xs={5} component={Box} py={2} display="flex" style={{alignItems:'center', justifyContent:'flex-end'}} >
            {actionButton}
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </Grid>
        <Grid component={Box} py={3} px={4} item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Container>
  );
};

export default PageWrapper;
